/* Register service worker for PWA / offline shell. No-op in dev for non-https. */
const isProd = process.env.NODE_ENV === "production";
const isHttps = window.location.protocol === "https:";

export default function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Avoid registering on http://localhost (non-https) in dev where SW behaves oddly,
  // but DO register on https preview hosts since CRA dev server still serves /service-worker.js.
  if (!isProd && !isHttps) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // listen for updates
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("pwa:update-available"));
            }
          });
        });
      })
      .catch(() => {});
  });
}

export function unregisterServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
}
